import React, { Component } from 'react';
import connect from "react-redux/es/connect/connect";
import * as wConsts from "../consts/website-consts";
import * as wActs from "../actions/website-actions";
import * as sActs from "../actions/server-actions";
import { FormattedMessage } from "react-intl";
import SeoHeaders from "../components/seoheaders";
import SideBanners from "../components/sidebanners";

class Confirm extends Component {

  constructor(props) {
    super(props);
    this.state = {
      email: wActs.getParameterByName("email","http://dummy.com/" + this.props.WebPage.ServerParams.Query,""),
      pin: wActs.getParameterByName("code","http://dummy.com/" + this.props.WebPage.ServerParams.Query,""),
      id: wActs.getParameterByName("id","http://dummy.com/" + this.props.WebPage.ServerParams.Query,""),
    }
    if(this.state.id === "") {
      this.state.id=this.state.email;
    }
  }

  componentDidMount() {
    this.setPin();
    if(!wActs.isNullOrEmpty(this.props.WebPage.Confirmation.EmailAddress)) {
      this.setState({id: this.props.WebPage.Confirmation.EmailAddress});
    }
  }

  getTranslation(key) {
    return this.props.WebPage.Translations[key];
  }

  keyPress(n) {
    n=n+1;
    if(n>6) {
      n=1;
    }
    eval("this.Pin"+n+".focus()");
  }

  setPin() {
    if(this.state.pin.length>=6) {
      this.Pin1.value = this.state.pin[0];
      this.Pin2.value = this.state.pin[1];
      this.Pin3.value = this.state.pin[2];
      this.Pin4.value = this.state.pin[3];
      this.Pin5.value = this.state.pin[4];
      this.Pin6.value = this.state.pin[5];
    }
  }

  getPin() {
    let pin ="";
    pin += this.Pin1.value;
    pin += this.Pin2.value;
    pin += this.Pin3.value;
    pin += this.Pin4.value;
    pin += this.Pin5.value;
    pin += this.Pin6.value;
    return pin;
  }


  sendConfirm(e) {
    e.preventDefault();
    let dta = {
      Id: this.Id.value,
      Code: this.getPin(),
      Source: "escortnews"
    }
    this.props.dispatch(wActs.SendConfirmation(dta,this.props.history, wActs.getCultPath(this.props.WebPage,"/login")));
  }

  getHeaderMarkup(key) {
    return {__html: this.getTranslation(key)};
  }
  render() {
    let showId = "";
    if(this.state.id !== "" || this.state.email !== "") {
      showId = " dis-none";
    }
    return (
      <div className="">
        <SeoHeaders Position={"Top"}/>
        <div className="row">
          <div className={"col_80"}>
            <div className="white-box the-content">
              <form action={""}>
              <div className="white-section" style={{background: "white", paddingTop: "25px"}}>
                <div className="section-content">
                  <div className="centered-content confirm-account-section">
                      {showId==="" &&
                        <p dangerouslySetInnerHTML={this.getHeaderMarkup("page.signup.thankyouforyourregistrationtext")}></p>
                      }
                      {showId!=="" &&
                        <p dangerouslySetInnerHTML={this.getHeaderMarkup("page.confirm.main")}></p>
                      }
                      <div className={"input-block" + showId}>
                        <label>Id</label>
                        <input ref={(ref) => {this.Id = ref}}  type="text" id="id" name=""  defaultValue={this.state.id}/>
                      </div>
                      <div className="centered-content small-mt"><h4>{this.getTranslation("page.pincode")}</h4></div>
                      <div className="pin-wrapper">
                        <div data-pin="">
                          <input onKeyPress={(key)=> {this.keyPress(1)}} ref={(ref) => {this.Pin1 = ref}} type="text" name="pin_0" data-vvalid="numeric|min:1|max:1" maxLength="1"/>
                          <input onKeyPress={(key)=> {this.keyPress(2)}} ref={(ref) => {this.Pin2 = ref}} type="text" name="pin_1" data-vvalid="numeric|min:1|max:1" maxLength="1"/>
                          <input onKeyPress={(key)=> {this.keyPress(3)}} ref={(ref) => {this.Pin3 = ref}} type="text" name="pin_2" data-vvalid="numeric|min:1|max:1" maxLength="1"/>
                          <input onKeyPress={(key)=> {this.keyPress(4)}} ref={(ref) => {this.Pin4 = ref}} type="text" name="pin_3" data-vvalid="numeric|min:1|max:1" maxLength="1"/>
                          <input onKeyPress={(key)=> {this.keyPress(5)}} ref={(ref) => {this.Pin5 = ref}} type="text" name="pin_4" data-vvalid="numeric|min:1|max:1" maxLength="1"/>
                          <input onKeyPress={(key)=> {this.keyPress(6)}} ref={(ref) => {this.Pin6 = ref}} type="text" name="pin_5" data-vvalid="numeric|min:1|max:1" maxLength="1"/>
                        </div>
                        <p className="message"></p>
                      </div>

                      {this.props.Confirmation.Status !== wConsts.CONFIRM_STATUS_PENDING &&
                      <div className="centered-content " style={{marginTop: "50px"}}>
                        <input type="submit" className="blueButton" title="" onClick={(e) => { this.sendConfirm(e); }} value={this.getTranslation("page.confirm.confirmaccount")}/>
                      </div>
                      }
                      {this.props.Confirmation.Status === wConsts.CONFIRM_STATUS_PENDING &&
                      <div className="centered-content " style={{marginTop: "50px"}}>
                        <img src={"/imgs/loader.gif"} width={"58"} height={"58"} alt={"loading..."} style={{margin: "auto", contentAlign: "center", justifyContent: "center", display: "flex"}}/>
                      </div>
                      }
                    <div style={{height: "100px"}}></div>
                  </div>
                </div>
              </div>
              </form>
              <div style={{ width: "90%", height: "300px" }}>&nbsp;</div>
            </div>
          </div>
          <SideBanners/>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    WebPage: state.Website,
    Confirmation: state.Website.Confirmation
  };
}

export default connect(mapStateToProps)(Confirm);
